<script>
import API from '@/core/api'
import Multiselect from 'vue-multiselect'
import LocationService from '@/MainServices/LocationService.js'
import IndexService from '@/MainServices/IndexService.js'
import {
  ArrowUpIcon,
  HeartIcon,
  EyeIcon,
  ShoppingCartIcon,
} from 'vue-feather-icons'
import skeleton_deatils_tiels from '@/view/front/components/skeleton_deatils_tiels'
// import Course from "@/view/front/components/course";

export default {
  components: {
    Multiselect,
    // ArrowUpIcon,
    skeleton_deatils_tiels,
    // Course
  },
  data() {
    return {
      api: API.API_HOME,
      search_text: '',
      courses: [],
      selected_cities: [],
      cities: [],
      selected_universites: [],
      universites: [],
      disciplines: [],
      selected_disciplines: [],
      selected_levels: [],
      levels: [],
      dets: [],
      selected_levels_v: [],
      showDetsDisplay: false,
      loading: true,
      page_num: 1,
      show_load_more: true,
      selected_index: -1,
      uni_id: this.$route.params ? this.$route.params.uni_id : null,
      uni_name: this.$route.params ? this.$route.params.uni_name : null,
      fname: "",
      lname: "",
      email: "",
      subject: "",
      message: "",
      sendToEmail: "",
      form_fillter: false,
    }
  },
  methods: {
    form_hide(){
      this.form_fillter = !this.form_fillter;
    },
    onImageLoadFailure(event) {
      event.target.src = '/images/uni_demo_profile.png'
    },
    submit() {
      const submitButton_ch = this.$refs["kt_login_signin_submit"];
      submitButton_ch.classList.add("spinner", "spinner-light", "spinner-right");
        this.sendToEmail = "umer.isetech@gmail.com";
        IndexService.contactMyUni(this.fname, this.lname, this.email, this.subject, this.message, this.sendToEmail).then((res)=> {
          Swal.fire({
            title: "",
            text: res.data,
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          submitButton_ch.classList.add("spinner", "spinner-light", "spinner-right");
        }).catch((error) => {
          Swal.fire({
            title: "",
            text: "Please, provide correct data!",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          submitButton_ch.classList.add("spinner", "spinner-light", "spinner-right");
        });
    },
    search: function (page_num, load_more, clearfilter = false) {
      let universities = []
      this.selected_universites.map((el) => {
        universities.push(el.id)
      })
      let disciplines = []
      this.selected_disciplines.map((el) => {
        disciplines.push(el.id)
      })

      let cities = []
      this.selected_cities.map((el) => {
        cities.push(el.id)
      })
      this.selected_levels_v = this.selected_levels.map(({ value }) => value)
      if (clearfilter) {
        this.search_text = ''
        universities = []
        cities = []
        this.selected_disciplines = []
        this.selected_levels = []
        this.selected_levels_v = []
        this.selected_universites = []
      }

      IndexService.searchCourses(
        page_num,
        this.search_text,
        cities,
        universities,
        disciplines,
        this.selected_levels.map(({ id }) => id),
      ).then((res) => {
        // this.loading = false
        if (this.selected_levels_v.length) {
          res.data = res.data.filter((course) =>
            this.selected_levels_v.includes(course.level),
          )
        }
        if (res.data.length < 14) {
          this.show_load_more = false
        }
        if (load_more) {
          this.courses = [...this.courses, ...res.data]
          this.loading = false
        } else {
          this.loading = false
          this.courses = res.data
        }
      })
    },
    showDets: function (id) {
      this.dets = this.courses[id]
      this.showDetsDisplay = true
      this.selected_index = id
    },
    loadmore() {
      this.page_num = this.page_num + 1
      this.search(this.page_num, true)
    },
    clearFilter() {
      this.search(1, true, true)
    },
  },
  mounted() {
    if (this.uni_id != null) {
      this.selected_universites.push({ id: this.uni_id, value: this.uni_name })
    }
    if (
      this.$session.exists('searchInput') ||
      this.$session.exists('selected_cities')
    ) {
      if (this.$session.exists('searchInput')) {
        this.search_text = this.$session.get('searchInput')
        this.$session.remove('searchInput')
      }
      if (this.$session.exists('selected_cities')) {
        this.selected_cities = this.$session.get('selected_cities')
        this.$session.remove('selected_cities')
      }

      this.search(this.page_num, true)
    }

    IndexService.getUniversitesWithListings().then((response) => {
      response.data.map((el) => {
        this.universites.push({ id: el.id, value: el.name })
      })
    })
    IndexService.getDisciplines()
      .then((res) => {
        res.data.map((el) => {
          this.disciplines.push({
            id: el.id,
            value: el.discipline,
          })
        })
      })
      .catch((e) => {})
    IndexService.getLevels()
      .then((res) => {
        res.data.map((el) => {
          this.levels.push({
            id: el.id,
            value: el.level,
          })
        })
      })
      .catch((e) => {})
    IndexService.getCities()
      .then((res) => {
        res.data.map((el) => {
          this.cities.push({
            id: el.id,
            value: el.city,
          })
        })
      })
      .catch((e) => {})
    this.search(1, false)
    // this.loading = false
  },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<template>
  <div>
    <section>
      <div class="r-c-search-page-cont-sec r-c-search-page-cont-sec2">
        <div class="row">
          <div
            class="col-xl-2 col-lg-4 col-md-4 col-sm-12 p-0 r-c-col-1-b-r mb-5"
          >
            <div class="r-c-search-page-filter-main-div-p-sticky">
              <div class="r-c-search-page-filter-main-div">
                <div
                  class="r-c-search-page-filter-sub-div r-c-d-flex justify-content-between pt-4"
                >
                  <h3
                    id="Courses-Filter"
                    class="r-c-search-page-filter-sub-div-heading"
                  >
                    Filters
                  </h3>
                  <button
                    @click="clearFilter"
                    type="button"
                    class="btn btn-outline-primary btn-sm r_courses-clear_filter_btn"
                  >
                    Clear Filter
                  </button>
                </div>
                <hr class="r-c-search-page-filter-hr" />
                <div class="row m-0 p-0">
                  <div class="col-12 p-0 col_scroll_filtter">
                    <div class="r-c-search-page-filter-sub-div">
                      <h3>Search Course</h3>
                      <input
                        type="text"
                        placeholder="Search Course"
                        v-model="search_text"
                        v-on:keyup.enter="search()"
                        class="r-c-search-page-filter-input"
                      />
                    </div>
                    <hr class="r-c-search-page-filter-hr" />

                    <div class="r-c-search-page-filter-sub-div">
                      <h3>Select university</h3>
                      <multiselect
                        class="r-c-search-page-filter-input"
                        id="multiselectUniversties"
                        v-model="selected_universites"
                        :height="300"
                        :options="universites"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                        placeholder="Select Universities"
                        label="value"
                        track-by="value"
                        :preselect-first="false"
                      ></multiselect>
                    </div>
                    <hr class="r-c-search-page-filter-hr" />

                    <div class="r-c-search-page-filter-sub-div">
                      <h3>Select discipline</h3>

                      <multiselect
                        class="r-c-search-page-filter-input"
                        id="multiselectUniversties"
                        v-model="selected_disciplines"
                        :height="300"
                        :options="disciplines"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                        placeholder="Select Disciplines"
                        label="value"
                        track-by="value"
                        :preselect-first="false"
                      ></multiselect>
                    </div>
                    <hr class="r-c-search-page-filter-hr" />

                    <div class="r-c-search-page-filter-sub-div">
                      <h3>Select city</h3>
                      <multiselect
                        class="r-c-search-page-filter-input"
                        id="multiselectCities"
                        v-model="selected_cities"
                        :height="300"
                        :options="cities"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                        placeholder="Select Cities"
                        label="value"
                        track-by="value"
                        :preselect-first="false"
                      ></multiselect>
                      <!-- </div> -->
                    </div>
                    <hr class="r-c-search-page-filter-hr" />

                    <div class="r-c-search-page-filter-sub-div">
                      <h3>Select degree</h3>
                      <div class="r-c-search-filter-s-degrees">
                        <div
                          class="r-c-s-filter-div-d-l"
                          v-for="(level, id) in levels"
                          :key="id"
                        >
                          <input
                            type="checkbox"
                            name="level"
                            :value="level"
                            :id="'level-' + id"
                            v-model="selected_levels"
                          />
                          <label :for="id">{{ level.value }}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr class="r-c-search-page-filter-hr" />
                <div
                  class="r-c-search-page-filter-sub-div r-c-filter-apply-btn-stcky"
                >
                  <div
                    class="r-c-search-page-result-card-det-div-btnn-prim-div"
                  >
                    <button
                      class="btn btn-primary r-c-search-page-result-card-det-div-btnn-prim"
                      @click="search()"
                    >
                      <!-- <a href="#Courses-Filter" class="text-white"> -->
                      Apply
                      <!-- </a> -->
                    </button>
                    <button
                      @click="clearFilter"
                      type="button"
                      class="btn btn-primary r-c-search-page-result-card-det-div-btnn-prim ml-2"
                    >
                      Clear
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-5 col-lg-8 col-md-8 col-sm-12 mb-5 pt-0">
            <skeleton_deatils_tiels v-if="loading" />
            <div class="emptay" v-if="!courses.length">
              There are no Courses Available
            </div>
            <div
              class="r-c-search-page-result-card-div row"
              :class="[
                selected_index == index ? 'green_outline' : '',
                index != courses.length - 1 ? 'r_mb_125px' : '',
              ]"
              v-for="(course, index) in courses"
              :key="index"
            >
              <div class="r-c-search-page-result-card-img-div col-5">
                <img
                  class="r-c-search-page-result-card-img"
                  @error="onImageLoadFailure($event)"
                  :src="api + `${course.images[0].image_path}` || ''"
                />
                <p class="r-c-search-page-result-card-det-div-uni">
                  {{ course.user }}
                </p>
              </div>
              <div class="r-c-search-page-result-card-det-div col-7">
                <h2 class="r-c-search-page-result-card-det-div-title">
                  {{ course.title }}
                </h2>
                <p class="r-c-search-page-result-card-det-div-desc">
                  {{ course.level }} | {{ course.duration }}
                </p>
                <hr class="r-c-search-page-result-card-det-div-hr" />
                <p class="r-c-search-page-result-card-det-div-uni-camp">
                  {{ course.campus }}, {{ course.city }}
                </p>
                <div class="row p-0 m-0">
                  <div class="col p-0">
                    <div
                      class="r-c-search-page-result-card-det-div-btn-div p-0"
                    >
                      <button
                        class="btn btn-outline-primary r-c-search-page-result-card-det-div-btnn"
                        @click="showDets(`${index}`)"
                      >
                        Details
                      </button>
                    </div>
                  </div>
                  <div class="col p-0">
                    <div class="r-c-search-page-result-card-det-div-rat">
                      <span
                        class="fa fa-star fa-xs r-c-search-page-result-card-det-div-star text-warning"
                      ></span>
                      <span
                        class="fa fa-star fa-xs r-c-search-page-result-card-det-div-star text-warning"
                      ></span>
                      <span
                        class="fa fa-star fa-xs r-c-search-page-result-card-det-div-star text-warning"
                      ></span>
                      <span
                        class="fa fa-star fa-xs r-c-search-page-result-card-det-div-star text-warning"
                      ></span>
                      <span
                        class="fa fa-star fa-xs r-c-search-page-result-card-det-div-star text-warning"
                      ></span>
                      <span>(5.0)</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="col-xl-5 col-lg-12 col-md-12 col-sm-12 p-0 mb-5"
            v-show="showDetsDisplay"
            v-if="showDetsDisplay"
          >
            <div class="r-c-search-page-result-card-dets-main-div">
              <span class="bg-white">
                <div class="r-c-search-page-result-card-dets-top-div bg-white">
                  <div
                    class="r-c-search-page-result-card-dets-top-cor-div justify-content-between"
                  >
                    <h2 class="r-c-search-page-result-card-dets-top-cor-name">
                      {{ dets.title }}
                    </h2>
                    <button
                      class="r-c-search-page-result-card-dets-top-cor-x"
                      @click="
                        showDetsDisplay = !showDetsDisplay
                        form_fillter = false
                        selected_index = -1
                      "
                    >
                      <img src="/images/myuni/courses/PNG/close.png" />
                    </button>
                  </div>
                  <p class="r-c-search-page-result-card-dets-top-cor-prog">
                    {{ dets.level }}
                  </p>
                  <div class="r-c-search-page-result-card-dets-top-cor-uni-d">
                    <a
                      class="r-c-search-page-result-card-dets-top-cor-uni-n"
                      href="#"
                    >
                      {{ dets.user }}, {{ dets.city }}
                    </a>
                    <div
                      class="r-c-search-page-result-card-dets-top-cor-uni-r-d"
                    >
                      <span
                        class="fa fa-star fa-xs r-c-search-page-result-card-dets-top-cor-uni-r-star text-warning"
                      ></span>
                      <span
                        class="fa fa-star fa-xs r-c-search-page-result-card-dets-top-cor-uni-r-star text-warning"
                      ></span>
                      <span
                        class="fa fa-star fa-xs r-c-search-page-result-card-dets-top-cor-uni-r-star text-warning"
                      ></span>
                      <span
                        class="fa fa-star fa-xs r-c-search-page-result-card-dets-top-cor-uni-r-star text-warning"
                      ></span>
                      <span
                        class="fa fa-star fa-xs r-c-search-page-result-card-dets-top-cor-uni-r-star text-warning"
                      ></span>
                      <span class="ml-2">(5.0)</span>
                    </div>
                  </div>
                </div>
                <hr
                  class="r-c-search-page-result-card-dets-main-div-hr bg-white"
                />
                <div
                  class="r-c-search-page-result-card-dets-main-div-3 bg-white"
                >
                  <div class="r-c-d-flex">
                    <button
                      class="btn btn-success r-c-search-page-result-card-det-div-btnn-succ ml-0"
                      id="send_enquiry"
                      @click="form_hide"
                    >
                    Send enquiry
                    </button>
                    <button
                      class="btn btn-outline-primary r-c-search-page-result-card-det-div-btnn-out-prim"
                    >
                      Details on university website
                    </button>
                    <router-link
                     v-if="dets.form_id != null"
                      class="mx-2 btn btn-primary r-c-search-page-result-card-det-div-btnn-prim"
                      style="font-size: 14px !important;"
                      :to="{
                        name: 'apply',
                        params: {
                          country: dets.country.toLowerCase().trim(),
                          city: dets.city.toLowerCase().trim(),
                          uni_name: dets.user_slug.toLowerCase().trim(),
                          level: dets.level
                            .replace(' ', '-')
                            .toLowerCase()
                            .trim(),
                          slug: dets.slug,
                          form_id: dets.form_id,
                        },
                      }"
                    >
                      Apply
                    </router-link>
                  </div>
                </div>
                <hr
                  class="r-c-search-page-result-card-dets-main-div-hr bg-white"
                />
              </span>
              <div class="r-c-search-page-result-card-dets-main-div-2">
                <!-- ///////////////////////////////////////////// -->
                <div class="filterform" v-if="form_fillter">
                  <!-- <h2 class="r_list_dets_page_dd_sect_contct_h pb-2">
                    Contact the institute
                  </h2>
                  <hr class="r_list_dets_page_dd_sect_contct_hr" /> -->
                  <form action="/action_page.php">
                    <div class="row">
                      <div class="col-lg-6">
                        <div class="form-group">
                          <label
                            class="r_list_dets_page_dd_sect_contct_lbl"
                            for="fname"
                          >
                            First name
                            <span class="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            v-model="fname"
                            class="form-control r_list_dets_page_dd_sect_contct_input"
                            id="fname"
                            placeholder="First name"
                            name="fname"
                          />
                        </div>
                      </div>
                      <div class="col-lg-6">
                        <div class="form-group">
                          <label
                            class="r_list_dets_page_dd_sect_contct_lbl"
                            for="lname"
                          >
                            Last name
                            <span class="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            v-model="lname"
                            class="form-control r_list_dets_page_dd_sect_contct_input"
                            id="lname"
                            placeholder="Last name"
                            name="lname"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        class="r_list_dets_page_dd_sect_contct_lbl"
                        for="email"
                      >
                        Your email address
                        <span class="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        v-model="email"
                        class="form-control r_list_dets_page_dd_sect_contct_input"
                        id="email"
                        placeholder="Your email address"
                        name="email"
                      />
                    </div>
                    <div class="form-group">
                      <label
                        class="r_list_dets_page_dd_sect_contct_lbl"
                        for="subject"
                      >
                        Subject Name
                        <span class="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        v-model="subject"
                        class="form-control r_list_dets_page_dd_sect_contct_input"
                        id="subject"
                        placeholder="Subject name"
                        name="subject"
                      />
                    </div>
                    <div class="form-group">
                      <label
                        class="r_list_dets_page_dd_sect_contct_lbl"
                        for="message"
                      >
                        Your message
                        <span class="text-danger">*</span>
                      </label>
                      <textarea
                        v-model="message"
                        class="form-control r_list_dets_page_dd_sect_contct_input"
                        row="15"
                        id="message"
                        placeholder="Your message"
                        name="message"
                      ></textarea>
                    </div>
                    <button
                      type="button"
                      @click="submit"
                      class="btn btn-primary r_list_dets_page_dd_sect_contct_sbmt_btn"
                      ref="kt_login_signin_submit"
                    >
                      Send Enquiry
                      <i class="fas fa-play"></i>
                    </button>
                  </form>
                  <hr
                  class="r-c-search-page-result-card-dets-main-div-hr bg-white"
                />
                </div>
                <!-- //////////////////////////////////////////// -->
                <div
                  class="r-c-search-page-result-card-dets-main-div-2-dt-div r-c-d-flex justify-content-between"
                >
                  <div class="r-c-d-flex">
                    <img
                      class="r-c-search-page-result-card-dets-main-div-2-img"
                      src="/images/myuni/courses/SVG/course_duration.svg"
                    />
                    <p class="r-c-search-page-result-card-dets-main-div-2-p">
                      {{ dets.duration }}
                    </p>
                  </div>

                  <div class="r-c-d-flex">
                    <img
                      class="r-c-search-page-result-card-dets-main-div-2-img"
                      src="/images/myuni/courses/SVG/credit_hours.svg"
                    />
                    <p class="r-c-search-page-result-card-dets-main-div-2-p">
                      {{ dets.credit_hours }} hours
                    </p>
                  </div>
                </div>
                <div class="r-c-search-page-result-card-dets-main-div-2-dt-div">
                  <div class="r-c-d-flex">
                    <img
                      class="r-c-search-page-result-card-dets-main-div-2-img"
                      src="/images/myuni/courses/SVG/location.svg"
                    />
                    <p class="r-c-search-page-result-card-dets-main-div-2-p">
                      {{ dets.campus }} - {{ dets.city }}, {{ dets.country }}
                    </p>
                  </div>
                </div>
                <div class="r-c-search-page-result-card-dets-main-div-2-dt-div">
                  <div class="r-c-d-flex position-relative">
                    <img
                      class="r-c-search-page-result-card-dets-main-div-2-img position-absolute"
                      src="/images/myuni/courses/SVG/eligibility_criteria.svg"
                    />
                    <p
                      class="r-c-search-page-result-card-dets-main-div-2-p r-c-p-t-ml"
                      v-html="dets.eligibility_criteria"
                    ></p>
                  </div>
                </div>
              </div>
              <hr class="r-c-search-page-result-card-dets-main-div-hr" />

              <div class="r-c-search-page-result-card-dets-main-div-4">
                <div class="r-c-search-page-result-card-dets-sub-div-4">
                  <h4 class="r-c-search-page-result-card-dets-sub-div-4-h">
                    Description
                  </h4>
                  <p
                    class="r-c-search-page-result-card-dets-sub-div-4-p"
                    v-html="dets.description"
                  ></p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-5 col-lg-12 col-md-12 col-sm-12 p-0 mb-5">
            <div class="r-c-search-page-result-card-dets-main-div p-0">
              <img
                src="/images/Side_bar.jpg"
                style="width: 100%;"
                class=""
                alt="PlaceHolder img"
                v-if="!showDetsDisplay"
              />
            </div>
          </div>
          <div class="col-md-12 mt-10" style="text-align: center;">
            <button
              type="button"
              @click="loadmore"
              class="btn btn-primary r-c-search-page-result-card-det-div-btnn-prim"
              v-if="show_load_more"
            >
              Load More Courses
            </button>
            <p v-if="!show_load_more"><b>Search Result End</b></p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
